module.exports = __webpack_public_path__ + "static/media/27.7edc69e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/27.jpg
// module id = 396
// module chunks = 0